module.exports = __webpack_public_path__ + "static/media/pin-default-viajes.cd801d4a.png";